"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _Tracking = require("../../lib/constants/Tracking");
var _utils = require("../../lib/utils");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
const RescheduleComponent = _ref => {
  let {
    appointment,
    createRescheduleLink,
    locationId,
    locations,
    provider,
    providerId,
    searchProvidersLink,
    track
  } = _ref;
  const {
    patientRelationship,
    patientPurpose,
    startDateTime
  } = appointment;

  // Sidebar adapter
  const appointmentQuery = {
    patientRel: patientRelationship,
    purpose: {
      name: patientPurpose
    }
  };
  const selectedAppointment = {
    start_datetime: startDateTime,
    location_id: locationId
  };
  const handleRescheduleButtonClick = () => {
    track(_Tracking.userEvents.CLICK_RESCHEDULE_CTA);
  };
  const handleNewSearchButtonClick = () => {
    track(_Tracking.userEvents.CLICK_NEW_SEARCH_CTA);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.Section, null, /*#__PURE__*/_react.default.createElement(_styles.UserMDStyled, {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.SectionHeading, null, (0, _utils.hasProvider)(provider) ? /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.rescheduleHeading, {
    values: {
      provider_name: (0, _providerComponents.getProviderDisplayName)(provider)
    }
  })) : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.rescheduleUnnamedHeading)), (0, _utils.hasProvider)(provider) ? /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderSidebar, {
    provider: provider,
    locations: locations,
    appointmentQuery: appointmentQuery,
    selectedAppointment: selectedAppointment,
    track: track,
    showApptTime: false,
    showSchedulingHelpBanner: false
  }, /*#__PURE__*/_react.default.createElement(_styles.SideBarButton, {
    "data-testid": "reschedule-sidebar-deep-link-button",
    mode: "primary",
    onClick: handleRescheduleButtonClick,
    href: createRescheduleLink(providerId, patientRelationship, patientPurpose)
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.rescheduleLinkText))) : /*#__PURE__*/_react.default.createElement(_styles.ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_styles.Button, {
    "data-testid": "reschedule-deep-link-button",
    mode: "primary",
    onClick: handleRescheduleButtonClick,
    href: createRescheduleLink(providerId, patientRelationship, patientPurpose)
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.rescheduleLinkText))))), /*#__PURE__*/_react.default.createElement(_styles.Section, null, /*#__PURE__*/_react.default.createElement(_styles.SearchStyled, {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.SectionHeading, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.newSearchHeading)), /*#__PURE__*/_react.default.createElement(_styles.ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_styles.Button, {
    "data-testid": "reschedule-search-button",
    mode: "ghost",
    onClick: handleNewSearchButtonClick,
    href: searchProvidersLink
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.newSearchLinkText))))));
};
RescheduleComponent.propTypes = {
  /**
   * The appointment object
   */
  appointment: (0, _propTypes.shape)({
    patientPurpose: _propTypes.string.isRequired,
    patientRelationship: _propTypes.string.isRequired,
    startDateTime: _propTypes.string.isRequired
  }).isRequired,
  /**
   * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
   * @callback createRescheduleLink
   * @param {number} providerId
   * @param {string} patientRelationship
   * @param {string} patientPurpose
   */
  createRescheduleLink: _propTypes.func.isRequired,
  /**
   * The ID of the location assoicated with the appointment
   */
  locationId: _propTypes.number.isRequired,
  /**
   * An array of the providers locations
   */
  locations: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
  /**
   * The provider object associated with the appointment if it was fetched
   */
  provider: _propTypes.object,
  /**
   * The ID of the provider associated with the appointment
   */
  providerId: _propTypes.number.isRequired,
  /**
   * URL link for the `Search Providers` button.
   */
  searchProvidersLink: _propTypes.string.isRequired,
  /**
   * Callback triggered for tracking
   * @callback track
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired
};
var _default = exports.default = RescheduleComponent;
RescheduleComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RescheduleComponent",
  "props": {
    "appointment": {
      "description": "The appointment object",
      "type": {
        "name": "shape",
        "value": {
          "patientPurpose": {
            "name": "string",
            "required": true
          },
          "patientRelationship": {
            "name": "string",
            "required": true
          },
          "startDateTime": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    },
    "createRescheduleLink": {
      "description": "Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment\n@callback createRescheduleLink\n@param {number} providerId\n@param {string} patientRelationship\n@param {string} patientPurpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "locationId": {
      "description": "The ID of the location assoicated with the appointment",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "locations": {
      "description": "An array of the providers locations",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": true
    },
    "provider": {
      "description": "The provider object associated with the appointment if it was fetched",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "providerId": {
      "description": "The ID of the provider associated with the appointment",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "searchProvidersLink": {
      "description": "URL link for the `Search Providers` button.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback track\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};